import { Routes, RouterModule } from '@angular/router';
import { ManualInputUpdateComponent } from './manual-input-update.component';
import { NgModule } from '@angular/core';



const routes: Routes = [
	{
		path: '',
		component: ManualInputUpdateComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})

export class ManualInputUpdateRoutingModule { }